import defaultAvatar from "assets/images/default-avatar.png";
import "components/ui/UserDetail/UserDetail.scss";
import PropTypes from "prop-types";
import ResponsiveImage from "components/ui/ResponsiveImage/ResponsiveImage";
import { Link } from "react-router-dom";
import HTMLContainer from "components/ui/HTML/HTMLContainer";

function UserDetail({ image, username, subtext, url, marginBottom }) {
  return (
    <div className={ `user-detail ${ marginBottom ? 'user-detail--margin-bottom' : '' }` }>
      <ResponsiveImage value={ image } defaultImage={ defaultAvatar } className={ 'user-detail__image' }/>

      <div className={ 'user-detail__text' }>
        <div className={ 'user-detail__name' }>
          { username || 'Onbekend profiel' }
        </div>

        <div className={ 'user-detail__subtext' }>
          <HTMLContainer value={ subtext }/>
        </div>
      </div>

      { url &&
      <Link to={ url } className={ 'link-overlay' } aria-label={ 'Ga naar profiel' }/>
      }
    </div>
  );
}

UserDetail.propTypes = {
  image: PropTypes.string,
  username: PropTypes.string,
  subtext: PropTypes.string,
  url: PropTypes.string,
  marginBottom: PropTypes.bool,
}

export default UserDetail;
